import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import Button from "@mui/material/Button";
import DataSummaryHeader from './DataVolume';

export default function Home() {
    return (
        <React.Fragment>
            <div className="hero is-fullheight" style={{
                background: '#000 url("/static/images/anu23m.jpg") no-repeat left center fixed',
                backgroundSize: 'cover'
            }}>
                <div className="caption-top subtitle is-6 has-text-light" align="right" style={{padding: "10px"}} >Header Photo Credits: Blake Estes</div>
                <div className="hero-body">
                    <div className="container is-widescreen ">
                        <div className="columns has-text-left">
                            <div className="column is-6" >
                                <h1 className="title is-1 has-text-light">ANU 2.3m Archive</h1>
                                <h4 className="subtitle is-4 has-text-light">
                                    The ANU 2.3m Archive is an ongoing service to provide online access to the data observed
                                    to-date on the ANU 2.3m Telescope located at Siding Spring Observatory. Currently, data taken
                                    since automated operations began in 2022 is available.
                                </h4>
                                 <DataSummaryHeader />
                                <Button variant="contained" color="primary" className="m-r-sm" size="medium"
                                        component={RouterLink} to="/query/raw">Query Raw Data</Button>
                                <Button variant="contained" color="primary" className="m-r-sm" size="medium"
                                        component={RouterLink} to="/query/reduced">Query Reduced Data</Button>
                                <Button variant='contained' color="secondary" className="m-r-sm" size="medium"
                                        component={RouterLink} to="/metdata">Meteorological Data</Button>
                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
}